import { defineLocale } from "../composables/defineLocale.js";
export default defineLocale({
  name: "\u041C\u043E\u043D\u0433\u043E\u043B",
  code: "mn",
  messages: {
    inputMenu: {
      noMatch: "\u0422\u043E\u0445\u0438\u0440\u043E\u0445 \u043C\u044D\u0434\u044D\u044D\u043B\u044D\u043B \u043E\u043B\u0434\u0441\u043E\u043D\u0433\u04AF\u0439",
      noData: "\u041C\u044D\u0434\u044D\u044D\u043B\u044D\u043B \u0431\u0430\u0439\u0445\u0433\u04AF\u0439",
      create: '"{label}" \u04AF\u04AF\u0441\u0433\u044D\u0445'
    },
    calendar: {
      prevYear: "\u04E8\u043C\u043D\u04E9\u0445 \u0436\u0438\u043B",
      nextYear: "\u0414\u0430\u0440\u0430\u0430 \u0436\u0438\u043B",
      prevMonth: "\u04E8\u043C\u043D\u04E9\u0445 \u0441\u0430\u0440",
      nextMonth: "\u0414\u0430\u0440\u0430\u0430 \u0441\u0430\u0440"
    },
    inputNumber: {
      increment: "\u041D\u044D\u043C\u044D\u0445",
      decrement: "\u0425\u0430\u0441\u0430\u0445"
    },
    commandPalette: {
      placeholder: "\u041A\u043E\u043C\u043C\u0430\u043D\u0434 \u0431\u0438\u0447\u0438\u0445 \u044D\u0441\u0432\u044D\u043B \u0445\u0430\u0439\u043B\u0442 \u0445\u0438\u0439\u0445...",
      noMatch: "\u0422\u043E\u0445\u0438\u0440\u043E\u0445 \u043C\u044D\u0434\u044D\u044D\u043B\u044D\u043B \u043E\u043B\u0434\u0441\u043E\u043D\u0433\u04AF\u0439",
      noData: "\u041C\u044D\u0434\u044D\u044D\u043B\u044D\u043B \u0431\u0430\u0439\u0445\u0433\u04AF\u0439",
      close: "\u0425\u0430\u0430\u0445"
    },
    selectMenu: {
      noMatch: "\u0422\u043E\u0445\u0438\u0440\u043E\u0445 \u043C\u044D\u0434\u044D\u044D\u043B\u044D\u043B \u043E\u043B\u0434\u0441\u043E\u043D\u0433\u04AF\u0439",
      noData: "\u041C\u044D\u0434\u044D\u044D\u043B\u044D\u043B \u0431\u0430\u0439\u0445\u0433\u04AF\u0439",
      create: '"{label}" \u04AF\u04AF\u0441\u0433\u044D\u0445',
      search: "\u0425\u0430\u0439\u0445..."
    },
    toast: {
      close: "\u0425\u0430\u0430\u0445"
    },
    carousel: {
      prev: "\u04E8\u043C\u043D\u04E9\u0445",
      next: "\u0414\u0430\u0440\u0430\u0430\u0445",
      goto: "{slide}-\u0440 \u0445\u0443\u0443\u0434\u0441\u0430\u043D\u0434 \u0448\u0438\u043B\u0436\u0438\u0445"
    },
    modal: {
      close: "\u0425\u0430\u0430\u0445"
    },
    slideover: {
      close: "\u0425\u0430\u0430\u0445"
    },
    alert: {
      close: "\u0425\u0430\u0430\u0445"
    },
    table: {
      noData: "\u041C\u044D\u0434\u044D\u044D\u043B\u044D\u043B \u0431\u0430\u0439\u0445\u0433\u04AF\u0439"
    }
  }
});
